import { CellData, TaskColumnType } from '@common-components/tasks/columns-cells/cell-interface'
import { columnTypeList } from '@common-components/tasks/columns-cells/column-cell-defs'
import { TasksGroup } from '@common-models/task-group'
import { _taskgroupsSelectors } from "@common-reducers/DBServiceThunks"
import { pickerDialogActions } from '@common-reducers/PickerDialogReducer'
import { addNewColumnThunk } from '@common-reducers/TaskThunks'
import { useAppSelector } from '@common-reducers/hooks/store.hook'
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { AnalyticsService } from '@common-services/analytics-service'
import { supportedColumnTypes } from '@common-components/tasks-panel/import-tasks-from-excel/import-excel'

interface columnDataProps extends CellData {
    addNewColumnToImportModule?: (columnDescriptor: TaskColumnType<any>) => void
}


export default function AddColumnDialog({ groupId, addNewColumnToImportModule }: columnDataProps) {
    const dispatch = useAppDispatch()
    const analyticsService: AnalyticsService = new AnalyticsService();

    const tasksGroup = useAppSelector((state) => {
        return _taskgroupsSelectors.selectById(state, groupId ?? "")
    }) as TasksGroup | undefined;

    const addColumn = (columnDescriptor: TaskColumnType<any>) => {
        dispatch(addNewColumnThunk({
            type: columnDescriptor.type,
            title: columnDescriptor.title,
            boardId: tasksGroup?.boardId ?? 'No Board',
            width: columnDescriptor.width
        }))
        analyticsService.event("add_new_column", {
            category: "userEngagement",
            action: `add new column ${columnDescriptor.title}`,
        });

        dispatch(pickerDialogActions.closePickerDialog())
    }

    const handleClickColumn = (columnDescriptor: TaskColumnType<any>) => {
        if (addNewColumnToImportModule) {
            addNewColumnToImportModule(columnDescriptor)
        } else {
            addColumn(columnDescriptor)
        }
    }
    
    return (
        <div className="grid grid-cols-2 gap-0 bg-[var(--tasks-board-bg)] py-2" onClick={(e) => e.stopPropagation()}>
            {columnTypeList.filter(columnDescriptor => {
                let shouldFilter = !columnDescriptor.private
                if (addNewColumnToImportModule) {
                    shouldFilter = shouldFilter && supportedColumnTypes?.includes(columnDescriptor.type)
                }
                return shouldFilter
            }).map((columnDescriptor, index) =>
                <div key={index} onClick={(e) => e.stopPropagation()}>
                    <button
                        type="button"
                        className="flex items-center w-full text-left p-2 border-0 mx-[10px] my-0 rounded-[5px] cursor-pointer bg-transparent hover:bg-[var(--tasks-group-bg)] text-[var(--color-primary)] text-sm transition-colors duration-200"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClickColumn(columnDescriptor);
                        }} 
                        data-testid={`create-column-button-type-${columnDescriptor.type}`}>
                        <div 
                            className="flex items-center justify-center p-0 rounded-[5px] w-[22px] h-[22px]" 
                            style={{ backgroundColor: columnDescriptor.iconAccent }}
                        >
                            <columnDescriptor.icon color="var(--color-surface)" />
                        </div>
                        <span 
                            className="ml-1.5 font-['Inter']"
                        >
                            {columnDescriptor.title}
                        </span>
                    </button>
                </div>)}
        </div>
    )
}
